if (!customElements.get('tab-information')) {
	class TabInformation extends HTMLElement {
		static get observedAttributes() {
			return ['selected-index'];
		}

		connectedCallback() {
			this.buttons = Array.from(this.querySelectorAll('.tab-information__tab'));
			this.panels = Array.from(this.querySelectorAll('.tab-information__panel'));

			this.applyListIcons();

			this.buttons.forEach((button, index) => {
				button.addEventListener('click', () => {
					this.selectedIndex = index;
				});
			});

			if (window.Shopify && Shopify.designMode) {
				this.addEventListener('shopify:block:select', (event) => {
					const index = this.buttons.indexOf(event.target.closest('.tab-information__tab'));
					if (index > -1) this.selectedIndex = index;
				});
			}

			this.selectedIndex = this.selectedIndex;
		}

		applyListIcons() {
			this.panels.forEach((panel) => {
				const template = panel.querySelector('.tab-information__list-icon');
				const source = template && template.content ? template.content.querySelector('svg, img') : null;
				if (!source) return;

				panel.querySelectorAll('.rte ul').forEach((list) => {
					list.classList.add('has-icon-bullets');
					list.querySelectorAll(':scope > li').forEach((item) => {
						if (item.querySelector(':scope > .tab-information__bullet')) return;
						const icon = source.cloneNode(true);
						icon.classList.add('tab-information__bullet');
						icon.removeAttribute('width');
						icon.removeAttribute('height');
						item.prepend(icon);
					});
				});
			});
		}

		get selectedIndex() {
			return parseInt(this.getAttribute('selected-index'), 10) || 0;
		}

		set selectedIndex(index) {
			this.setAttribute('selected-index', index);
		}

		attributeChangedCallback(name, oldValue, newValue) {
			if (name !== 'selected-index' || !this.buttons) return;

			const activeIndex = parseInt(newValue, 10) || 0;

			this.buttons.forEach((button, index) => {
				const isActive = index === activeIndex;
				button.classList.toggle('active', isActive);
				button.setAttribute('aria-selected', isActive ? 'true' : 'false');
				button.setAttribute('tabindex', isActive ? '0' : '-1');
			});

			this.panels.forEach((panel, index) => {
				const isActive = index === activeIndex;
				panel.classList.toggle('active', isActive);
				this.setMediaState(panel, isActive);
			});
		}

		// A video only runs while its tab is open, so nothing plays behind a closed panel.
		setMediaState(panel, isActive) {
			panel.querySelectorAll('video').forEach((video) => {
				if (!isActive) {
					video.pause();
				} else if (video.autoplay) {
					const playing = video.play();
					if (playing) playing.catch(() => {});
				}
			});
		}
	}

	customElements.define('tab-information', TabInformation);
}
